var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.dialogLoginVisible)?_c('el-dialog',{attrs:{"width":"380px","custom-class":"login-dialog","visible":_vm.dialogLoginVisible},on:{"update:visible":function($event){_vm.dialogLoginVisible=$event},"close":_vm.dialogLoginClose}},[_c('Login')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }